import { PageLayout } from '@app/pages/layout/PageLayout'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { pages } from '@app/util/links'
import { KnowledgeHubModuleView } from './KnowledgeHubModule'

export type KnowledgeHubModulePageProps = {
  itemId: string
}

export const KnowledgeHubModulePage = ({
  itemId,
}: KnowledgeHubModulePageProps) => (
  <KnowledgeHubModuleView
    itemId={itemId}
    backPath={pages.knowledgeHub}
    renderReady={(body) => (
      <PageLayout gap="0rem">
        <PageSeo />
        {body}
      </PageLayout>
    )}
  />
)
